module.exports = __webpack_public_path__ + "img/segmentation.14dae948.png";